const inputFocusSelection = function (e) {
  const target = e.srcElement || e.target;
  target.select();
};

const inputFocusHelper = function (e) {
  const target = e.srcElement || e.target;
  const maxLength = parseInt(target.attributes.maxlength.value, 10);
  const length = target.value.length;
  const keyCode = e.key || e.keyCode;

  let sibling;

  switch (keyCode) {
    case 'Backspace':
    case 'ArrowLeft':
    case 'Left':
    case 8:
    case 37:
      sibling = target.parentNode.previousElementSibling;
      break;
    case 'ArrowRight':
    case 'Right':
    case 39:
      sibling = target.parentNode.nextElementSibling;
      break;
    default:
      if (length >= maxLength - 1 && length !== 0) {
        sibling = target.parentNode.nextElementSibling;
      }
  }

  if (sibling) {
    const input = sibling.querySelector('input:not(.js-hidden)');

    if (input) {
      input.focus();
      input.select();
    }
  }
};

export { inputFocusHelper, inputFocusSelection };
